export default __webpack_public_path__ + "static/media/undraw_pure_love_ay8a.852d35e4.svg";